//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ResponsiveImageStrapi from '@/components/modules/ResponsiveImageStrapi'

export default {
	props: {
		data: {
			type: Object,
			default: null,
		},
	},
	components: {
		ResponsiveImageStrapi,
	},

	computed: {
		projects() {
			// const re = this.$store.getters.cmsdata;
			// console.log('d index: ', re.home)
			return this.$store.getters.projects
		},
		projectsCat() {
			const categories = this.getArray(this.data.categories);
			if (categories.length){
				const final = Object.entries(this.projects).filter((project) => { 
					return categories.some(value => project[1].categories.map( (item) => item.id).includes(value))
				});
				return Object.fromEntries(final);
			} else {
				return this.projects;
			}
		},
		projects_recent() {
			const values = Object.values(this.projectsCat)
			return values.sort((a, b) => b.Year - a.Year)
		},
	},
	async asyncData({
		params,
		error,
		store
	}) {
		// console.log("async page _slug: ", params.slug);
		try {
			await store.dispatch('getProjectsAll')
		} catch (e) {
			error({
				statusCode: e.statusCode,
				message: e.message
			})
		}
	},
	methods: {
		isIncategory(cats) {
			const categories = this.getArray(this.data.categories);
			const projectcat = this.getArray(cats);
			return categories.some(value => projectcat.includes(value))
		},
		getArray(array) {
			return array.map( (item) => item.id);
		},
	}
}

